import React from 'react';
import Header from '../../Includes/Header';
import Footer from '../../Includes/Footer';
import "./MetronetProvider.css";
import provider0 from "../../Includes/Images/banner-image.png";
import provider2 from "../../Includes/Images/about-img.png";
import WideCoverage from './WideCoverage';
// Make sure FontAwesome is imported in your project
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faPhoneAlt } from '@fortawesome/free-solid-svg-icons';

const MetronetProvider = () => {
    // Consistent phone number across the page
    const phoneNumber = "+1-888-348-6689";

    return (
        <>
            <Header />
            <div className="Metro-container">
                <header className="Metro-header1">
                    <div className="Metro-logo">Metronet</div>
                </header>

                <section className="Metro-hero">
                    <div className="Metro-hero-content">
                        <div className="Metro-ghost-text">Metronet</div>
                        <h1 className="Metro-hero-title">Simply a Better Connection</h1>
                        <ul className="Metro-features">
                            <li>
                                <p>
                                    At Metronet, we are committed to bringing state-of-the-art telecommunication services to the communities we serve by delivering services comparable or superior to those offered in large metropolitan areas. This commitment not only means better internet, television and telephone options
                                </p>
                            </li>
                        </ul>
                        <div className="Metro-price">
                            <span className="Metro-dollar-sign">$</span>49.99<span className="Metro-price-month">/MO</span>
                        </div>
                        <br />
                        <a href={`tel:${phoneNumber.replace(/\s+/g, '')}`} className="Metro-phone">
                            <i className="fas fa-phone-alt"></i> {phoneNumber}
                        </a>
                    </div>
                    <div className="Metro-hero-image">
                        <img src={provider0} alt="Woman with colorful lighting" className="Metro-full-image1" />
                    </div>
                </section>
            </div>

            <section className="Metro-services">
                <div className="Metro-services-grid">
                    <div className="Metro-services-images">
                        <div className="Metro-image-container main-image">
                            <img src={provider2} alt="Woman with colorful lighting" className="Metro-full-image" />
                        </div>
                    </div>
                    <div className="Metro-services-content">
                    <div className="Metro-ghost-text">Metronet</div>
                    
                        <h2 className="Metro-services-title">
                        We are committed to bringing state-of-the-art telecommunication
                        </h2>
                        <p className="Metro-services-text">
                        WholeHome WiFi rate is based on regular rate. Regular WholeHome WiFi rate includes one WholeHome WiFi device. Extra devices will incur additional charges. Offers do not include taxes and fees. Additional installation fees may also apply. Regular rates apply upon service suspension, cancellation, or downgrades.                        </p>
                       
                        <a href={`tel:${phoneNumber.replace(/\s+/g, '')}`} className="Metro-cta-button">
                            <i className="fas fa-phone-alt"></i> {phoneNumber}
                        </a>
                    </div>
                </div>
            </section>

            <div className="Metro-offers-container">
                <div className="offers-header">
                    <h2 className="Metro-services-title">Experience a Fast, Secure Connection</h2>
                    <p>Connecting you to what matters the most!</p>
                </div>

                <div className="offers-cards">
                    {/* Basic Plan */}
                    <div className="Metro-offer-card metro-offer-card-basic">
                        <div className="offer-header">
                            <h3 className="offer-name">GET 300 MBPS</h3>
                            <p className="Metro-offer-price">$49.99<span>/Mo</span></p>
                        </div>
                        <div className="offer-features">
                            <div className="feature-item">
                                <span className="feature-check">✓</span>
                                <span className="feature-text">Download for 12 mos with Auto Pay</span>
                            </div>
                            <div className="feature-item">
                                <span className="feature-check">✓</span>
                                <span className="feature-text">Fast, reliable Internet up to 300 Mbps</span>
                            </div>
                        </div>
                        <div className="offer-footer">
                            <a href={`tel:${phoneNumber.replace(/\s+/g, '')}`} className="metro-call-button">{phoneNumber}</a>
                            <p className="disclaimer">Restrictions apply. Internet or TV req'd. Taxes extra. Pricing subj. to change</p>
                        </div>
                    </div>

                    {/* Standard Plan */}
                    <div className="metro-offer-card metro-offer-card-standard">
                        <div className="Metro-standard-offer-header">
                            <h3 className="offer-name">Fast Internet + Popular TV</h3>
                            <p className="standard-offer-price">$69.99 <span>/Mo</span></p>
                        </div>
                        <div className="offer-features">
                            <div className="feature-item">
                                <span className="feature-check">✓</span>
                                <span className="feature-text">for 24 mos with Auto Pay</span>
                            </div>
                            <div className="feature-item">
                                <span className="feature-check">✓</span>
                                <span className="feature-text">Faster speeds up to 500 Mbps</span>
                            </div>
                            <div className="feature-item">
                                <span className="feature-check">✓</span>
                                <span className="feature-text">Two-Year Price Guarantee</span>
                            </div>
                        </div>
                        <div className="offer-footer">
                            <a href={`tel:${phoneNumber.replace(/\s+/g, '')}`} className="metro-standard-call-button">{phoneNumber}</a>
                            <p className="disclaimer">Restrictions apply. Internet or TV req'd. Taxes extra. Pricing subj. to change</p>
                        </div>
                    </div>

                    {/* Premium Plan */}
                    <div className="metro-offer-card metro-offer-card-premium">
                        <div className="offer-header">
                            <h3 className="offer-name">Fast Internet + Popular TV + Voice</h3>
                            <p className="metro-offer-price">$79.99<span>/Mo</span></p>
                        </div>
                        <div className="offer-features">
                            <div className="feature-item">
                                <span className="feature-check">✓</span>
                                <span className="feature-text">for 24 mos with Auto Pay</span>
                            </div>
                            <div className="feature-item">
                                <span className="feature-check">✓</span>
                                <span className="feature-text">Twice as fast for only $10/mo more</span>
                            </div>
                            <div className="feature-item">
                                <span className="feature-check">✓</span>
                                <span className="feature-text">Two-Year Price Guarantee</span>
                            </div>
                        </div>
                        <div className="offer-footer">
                            <a href={`tel:${phoneNumber.replace(/\s+/g, '')}`} className="metro-call-button">{phoneNumber}</a>
                            <p className="disclaimer">Restrictions apply. Internet or TV req'd. Taxes extra. Pricing subj. to change</p>
                        </div>
                    </div>
                </div>
            </div>

            <WideCoverage />
            <Footer />
        </>
    );
};

export default MetronetProvider;